import { useEffect, useRef, useState } from 'react';
import { useClampedMenuPosition } from './useClampedMenuPosition.ts';

export interface TagContextMenuPosition {
  x: number;
  y: number;
  tagName: string;
}

interface Props {
  position: TagContextMenuPosition;
  onClose: () => void;
  onDelete: () => void;
  isDeleting: boolean;
  error: string | null;
  canDelete: boolean;
}

export function TagContextMenu({ position, onClose, onDelete, isDeleting, error, canDelete }: Props) {
  const [confirming, setConfirming] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { left, top } = useClampedMenuPosition(ref, position.x, position.y);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div ref={ref} className="commit-context-menu" style={{ left, top }}>
      <div className="ccm-header">
        <span className="ccm-sha">{position.tagName}</span>
      </div>
      <div className="ccm-separator" />
      {error ? (
        <div style={{ padding: '6px 14px' }}>
          <span className="badge error">Erreur : {error}</span>
        </div>
      ) : confirming ? (
        <button className="ccm-item" onClick={onDelete} disabled={isDeleting}>
          <span className="ccm-icon">⚠</span>
          <span>{isDeleting ? 'Suppression…' : 'Confirmer la suppression ?'}</span>
        </button>
      ) : (
        <button
          className="ccm-item"
          onClick={() => setConfirming(true)}
          disabled={!canDelete}
          title={canDelete ? undefined : 'Ton rôle sur ce dépôt (Guest/Reporter) ne permet pas de supprimer un tag'}
        >
          <span className="ccm-icon">🗑</span>
          <span>Supprimer le tag</span>
        </button>
      )}
    </div>
  );
}
